import _ from 'lodash'
import { AccountProductFeatureTypes } from '@/store/types'

export default {
  created() {
    this.AccountProductFeatureTypes = AccountProductFeatureTypes    
  },
  methods: {
    // Check if the account has access to a product feature
    // Done via the product access of account subscriptions
    accountHasProductFeature(featureType) {
      try {
        if(!_.isArray(this.$store.state.account.prodFeatureList))
          return false

        return this.$store.state.account.prodFeatureList.indexOf(featureType) != -1

      } catch {
        return false
      }
    },

    // Get an account setting boolean
    accountSettingGetValueBoolean(settingKey, defaultValue = false) {
      if(!this.$store.state.account || !this.$store.state.account.accountSettings)
        return defaultValue

      let settingValue = this.$store.state.account.accountSettings[settingKey]

      if(settingValue === undefined)
        return defaultValue

      if(typeof settingValue === 'boolean')
        return settingValue
      if(typeof settingValue === 'string') {
        if(settingValue.toLowerCase() == 'true' || settingValue.toLowerCase() == 'yes')
          return true
      }
      if(!isNaN(settingValue))
        return (parseFloat(settingValue) != 0)

      return false
    }
  }
}
